import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
export const PRODUCT_IMAGE = 'https://sb.impultienda.ar/storage/v1/object/public/store-resources/a9339a36-69e0-4384-a950-f2b119c462ba/1793853660455_caja-transp-e54e21b4.webp';
export const heroGuarantees = ['Natychmiastowy dostęp cyfrowy', 'Jednorazowa płatność', 'Bez abonamentu', '7 dni gwarancji satysfakcji'];
export const stats = [{
  value: '240',
  label: 'Stron w sześciu tomach'
}, {
  value: '6',
  label: 'Cyfrowych tomów szkółki pływackiej'
}, {
  value: '3–12',
  label: 'Lat – od kaczuszki do delfina'
}, {
  value: '5',
  label: 'Bonusów w cenie'
}, {
  value: '1',
  label: 'Kompletny system na basen'
}];
export const differenceStats = [{
  value: '6 etapów',
  label: 'Od oswojenia z wodą 3-latków do doskonalenia techniki 12-latków'
}, {
  value: '6 tomów cyfrowych',
  label: 'Od pierwszego wejścia do wody po żabkę, delfina i podstawy ratownictwa'
}, {
  value: 'PDF do druku',
  label: 'Na tablecie albo wydrukowane – prosto na brzeg basenu'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Niedzielne wieczory znikają',
  text: 'Godziny przy komputerze nad zajęciami na cały tydzień – i wciąż nie jest gotowe.'
}, {
  title: 'Godziny szukania',
  text: 'Zabawy i ćwiczenia z internetu są za łatwe, za trudne albo nie pasują do wieku Twoich dzieci.'
}, {
  title: 'Każde zajęcia od zera',
  text: 'Wejście do wody, rozgrzewka, ćwiczenia, zabawa, wyjście z basenu – coś, co powinno zająć kilka minut, zamienia się w osobną pracę.'
}, {
  title: 'Trudno pracować z różnymi poziomami',
  text: 'Dzieci, które jeszcze boją się wody, i te, które już pływają, w tej samej grupie: ktoś zawsze czeka.'
}, {
  title: 'Rodzice i oceny zajmują czas',
  text: 'Karty postępów, zmiany poziomu, wiadomości do rodziców: kolejna praca po zajęciach.'
}, {
  title: 'Stres przed zajęciami',
  text: 'Gdy brakuje czasu, improwizujesz i ratujesz sytuację w ostatniej chwili na brzegu basenu.'
}];
export const afterItems = ['Uporządkowany pakiet szkółki pływackiej dla dzieci od 3 do 12 lat', 'Zajęcia minuta po minucie, łatwe do poprowadzenia', 'Karty zajęć gotowe do druku od razu', 'Gotowe zabawy w wodzie dla każdego wieku', 'Style krok po kroku, od kaczuszki do delfina', '3 poziomy w tej samej grupie', 'Jasne zasady bezpieczeństwa na brzegu basenu', 'Gotowe karty postępów dla rodziców', 'Plan na cały sezon'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Weekendy na przygotowaniach',
  text: 'Czy spędzasz część weekendu na przygotowywaniu zajęć na kolejny tydzień?'
}, {
  icon: FolderSearchIcon,
  title: 'Nie wiesz już, jaką zabawę zaproponować',
  text: 'Czy ciągle szukasz zabaw i ćwiczeń dopasowanych do wieku Twoich dzieci?'
}, {
  icon: LightbulbIcon,
  title: 'Chcesz jaśniej tłumaczyć',
  text: 'Czy potrzebujesz materiałów wizualnych, żeby prosto wytłumaczyć dzieciom ruch?'
}, {
  icon: PencilRulerIcon,
  title: 'Chcesz przestać tworzyć wszystko od zera',
  text: 'Czy chcesz, żeby zajęcia, zabawy i karty były już gotowe?'
}, {
  icon: ShuffleIcon,
  title: 'Twoje dzieci potrzebują różnorodności',
  text: 'Czy chcesz mieć więcej zabaw, wyzwań i torów przeszkód, żeby utrzymać motywację grupy?'
}, {
  icon: LayoutGridIcon,
  title: 'Potrzebujesz jasnej struktury',
  text: 'Czy chcesz mieć wszystkie materiały w jednym miejscu i szybko znaleźć to, czego potrzebujesz?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Tom 01',
  level: '3–5 lat',
  title: 'Oswojenie z wodą',
  tagline: 'Pokonać strach i odkrywać wodę przez zabawę.',
  intro: 'Pierwszy tom prowadzi najmłodszych od brzegu basenu do wody, z zajęciami minuta po minucie opartymi na zabawie.',
  items: ['Powitanie i pierwsze wejście do wody', 'Dziecko, które boi się wody: co robić', 'Zabawy w brodziku', 'Bańki, chlapanie i twarz w wodzie', 'Zajęcia 30 i 45 minut', '3 poziomy w tej samej grupie', 'Karty zajęć do druku', 'Bezpieczeństwo i checklista', 'Karta postępów dla rodziców'],
  outro: 'Dzieci spokojne w wodzie od pierwszych zajęć.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 02',
  level: '4–6 lat',
  title: 'Unoszenie się na wodzie i oddychanie',
  tagline: 'Utrzymać się na wodzie i spokojnie oddychać.',
  intro: 'Drugi tom uczy unoszenia się na wodzie na brzuchu i na plecach oraz oddychania w wodzie, krok po kroku.',
  items: ['Gwiazda na brzuchu i na plecach', 'Unoszenie się z makaronem i deską', 'Wydech i robienie baniek', 'Zanurzanie i wyławianie przedmiotów', 'Równowaga i powrót do pionu', 'Zabawy w unoszenie się na wodzie', 'Progresje bez sprzętu', 'Karty zajęć do druku'],
  outro: 'Każde dziecko znajduje swoją równowagę w wodzie.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 03',
  level: '5–7 lat',
  title: 'Pierwsze pływanie',
  tagline: 'Pierwsze samodzielne ruchy rąk.',
  intro: 'Trzeci tom prowadzi dzieci od pracy nóg przez ślizg do pierwszego kraula.',
  items: ['Nogi do kraula z deską', 'Ślizg', 'Pierwsze ruchy rąk', 'Podstawy oddychania bokiem', 'Tory przeszkód i stacje', 'Zabawy do stylów', 'Częste błędy i korekty', 'Karty zajęć do druku'],
  outro: 'Dzień, w którym pływają same.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Tom 04',
  level: '6–9 lat',
  title: 'Pełny kraul i styl grzbietowy',
  tagline: 'Dwa pełne style, wyjaśnione prosto.',
  intro: 'Czwarty tom uzupełnia kraul i styl grzbietowy jasnymi progresjami i słowami zrozumiałymi dla dzieci.',
  items: ['Pełny kraul', 'Pełny styl grzbietowy', 'Oddychanie i rytm', 'Ćwiczenia z krótkimi płetwami i ósemką', 'Słowa-klucze dla dzieci', 'Zabawy i sztafety', 'Częste błędy i korekty', 'Odznaki postępów'],
  outro: 'Czyste style, pewne siebie dzieci.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 05',
  level: '8–11 lat',
  title: 'Żabka, delfin, nawroty i starty',
  tagline: 'Nowe style i nowe wyzwania.',
  intro: 'Piąty tom wprowadza żabkę, podstawy delfina, nawroty i bezpieczne starty.',
  items: ['Żabka krok po kroku', 'Podstawy delfina', 'Prosty nawrót i nawrót koziołkowy', 'Bezpieczny start z brzegu', 'Finisz', 'Zabawy i wyzwania', 'Częste błędy i korekty', 'Karty zajęć do druku'],
  outro: 'Cztery style, żeby rosnąć w wodzie.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Tom 06',
  level: '9–12 lat',
  title: 'Doskonalenie, zabawy i bezpieczeństwo',
  tagline: 'Pływacy kompletni i świadomi.',
  intro: 'Szósty tom doskonali style, proponuje zabawy w wodzie i uczy bezpieczeństwa oraz podstaw ratownictwa.',
  items: ['Doskonalenie stylów', 'Wytrzymałość i rytm', 'Zabawy w wodzie i sztafety', 'Bezpieczeństwo w wodzie', 'Podstawy ratownictwa dla dzieci', 'Pokaz na zakończenie kursu', 'Dyplomy', 'Karty postępów dla rodziców'],
  outro: 'Sezon, który kończy się świętem.',
  note: 'Materiał nie zastępuje szkolenia ani nadzoru ratownika na pływalni.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 cyfrowych tomów, jeden etap na każdy wiek',
  text: 'Kompletny pakiet szkółki pływackiej, który pomaga przygotować i poprowadzić kursy dla dzieci przez cały sezon. Każdy tom ma 40 stron zajęć, zabaw, ćwiczeń i kart na basen.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Gotowe zajęcia',
  text: 'Koniec z pustą kartką. Zajęcia minuta po minucie ze słowami instruktora – możesz zacząć od razu.'
}, {
  icon: FileTextIcon,
  title: 'Karty do druku',
  text: 'Karty zajęć, karty postępów i dyplomy do wydrukowania i zabrania na brzeg basenu.'
}, {
  icon: ShapesIcon,
  title: 'Ćwiczenia w obrazkach',
  text: 'Czytelne rysunki, ilustrowane etapy i proste słowa, które pomagają wytłumaczyć dzieciom każdy ruch.'
}, {
  icon: DicesIcon,
  title: 'Zabawy w wodzie',
  text: 'Zabawy dla każdego wieku, które uczą techniki przez zabawę, z makaronami, deskami i krążkami.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Oceny i odznaki',
  text: 'Karty postępów dla rodziców i odznaki poziomów od Kaczuszki do Orki.'
}, {
  icon: CalendarCheckIcon,
  title: 'Plan sezonu',
  text: 'Od września do czerwca: każdy etap ma swoje cele, zajęcia i zabawy.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/a9339a36-69e0-4384-a950-f2b119c462ba/1793864750303_t1-p01-85fb98a5.webp",
    "label": "Tom 01 · Strona 1",
    "title": "Okładka",
    "text": "Oswojenie z wodą dla dzieci od 3 do 5 lat."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/a9339a36-69e0-4384-a950-f2b119c462ba/1793864758228_t1-p04-5bdc37f5.webp",
    "label": "Plan sezonu · Strona 4",
    "title": "Plan sezonu",
    "text": "Od września do czerwca, miesiąc po miesiącu, z tematami, celami i wydarzeniami."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/a9339a36-69e0-4384-a950-f2b119c462ba/1793864766680_t1-p10-8343ae85.webp",
    "label": "Zajęcia 1 · Strona 10",
    "title": "Zajęcia 1 · Cześć, basenie!",
    "text": "Przebieg minuta po minucie, sprzęt i wskazówki instruktora."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/a9339a36-69e0-4384-a950-f2b119c462ba/1793864775346_t1-p11-4389172a.webp",
    "label": "Karta zajęć · Strona 11",
    "title": "Karta zajęć do druku",
    "text": "Czasy, plan basenu, 3 poziomy i bezpieczeństwo na jednej stronie."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/a9339a36-69e0-4384-a950-f2b119c462ba/1793864783344_t1-p39-371bd50b.webp",
    "label": "Rodzice · Strona 39",
    "title": 'Karta postępów dla rodziców',
    "text": "Umiejętności do odhaczenia i odznaka poziomu do wręczenia."
  }
];
export const pageTypes = ['Gotowe zajęcia', 'Karty do druku', 'Zabawy i ćwiczenia', 'Oceny i odznaki'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Biblia zabaw w wodzie – 100 zabaw do szkółki pływackiej',
  text: 'Zabawy, które uczą techniki przez zabawę, dla każdego wieku i każdej głębokości.',
  items: ['Oswojenie z wodą i strach', 'Unoszenie się na wodzie i oddychanie', 'Zabawy do stylów', 'Sztafety i drużyny'],
  benefit: 'Nowa zabawa na każdych zajęciach.'
}, {
  title: 'Rodzice po Twojej stronie – gotowe wiadomości i karty postępów',
  text: 'Wiadomości i karty postępów, które uspokajają rodziców przez cały sezon.',
  items: ['40 gotowych wiadomości', 'Karty postępów dla każdego poziomu', 'Dyplom do wręczenia', 'Karta rozmowy z rodzicami'],
  benefit: 'Spokojni rodzice, dzieci, które zostają.'
}, {
  title: 'Zanim wejdziesz do wody – 40 ćwiczeń na sucho dla dzieci',
  text: 'Ćwiczenia przy brzegu basenu, żeby rozgrzać, wytłumaczyć ruch i uspokoić grupę.',
  items: ['Rozgrzewka przez zabawę', 'Style na sucho', 'Oddychanie i dmuchanie', '8 rutyn po 5 minut'],
  benefit: 'Ruchu można się nauczyć także poza wodą.'
}, {
  title: 'Lekcje indywidualne i kursy wakacyjne – przewodnik instruktora',
  text: 'Gotowe programy lekcji indywidualnych, mini grup i kursów wakacyjnych.',
  items: ['Pakiety 5 i 10 lekcji', 'Mini grupy', 'Dwutygodniowy kurs wakacyjny', 'Wiadomości i plakat'],
  benefit: 'Więcej zajęć, lepiej zorganizowanych.'
}, {
  title: 'Encyklopedia błędów – 60 korekt dla dzieci',
  text: 'Najczęstsze błędy dzieci i jak je poprawić prostymi słowami.',
  items: ['60 zilustrowanych błędów', 'Zdanie do powiedzenia', '2 ćwiczenia korygujące', 'Tabela do zalaminowania'],
  benefit: 'Widzisz błąd i od razu wiesz, co powiedzieć.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Otwórz PŁYWANIE GOTOWE™',
  text: 'Pobierz pakiet i otwórz tom, który pasuje do wieku Twojej grupy.'
}, {
  title: 'Wybierz zajęcia',
  text: 'Znajdź etap i temat, a potem wybierz zajęcia, zabawę albo kartę, która pasuje do Twoich dzieci.'
}, {
  title: 'Przygotuj się w 5 minut',
  text: 'Przeczytaj przebieg zajęć i przygotuj potrzebny sprzęt.'
}, {
  title: 'Wydrukuj i idź na basen',
  text: 'Wydrukuj kartę zajęć albo otwórz ją na tablecie – i zacznij z jasnym planem.'
}];
export const audienceItems = ['Uczysz pływania dzieci od 3 do 12 lat', 'Chcesz mieć uporządkowany cały sezon szkółki pływackiej', 'Chcesz przestać przygotowywać każde zajęcia od zera', 'Masz różne poziomy w tej samej grupie', 'Szukasz bezpiecznych i różnorodnych zabaw i ćwiczeń', 'Chcesz mieć gotowe karty postępów i odznaki dla rodziców', 'Chcesz oszczędzać czas co tydzień', 'Chcesz czuć się przygotowany przed każdymi zajęciami'];
export const timeValueTasks = ['Szukanie zabaw i ćwiczeń', 'Pisanie przebiegu zajęć', 'Przygotowanie sprzętu i torów przeszkód', 'Organizacja grup i poziomów', 'Ocenianie dzieci i wiadomości do rodziców'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 cyfrowych tomów – 240 stron',
  detail: 'Oswojenie z wodą, unoszenie się na wodzie, pierwsze pływanie, kraul i styl grzbietowy, żabka i delfin, doskonalenie'
}, {
  label: '5 bonusów bez dodatkowych kosztów',
  detail: 'Zabawy w wodzie, wiadomości i karty postępów dla rodziców, ćwiczenia na sucho, lekcje indywidualne i błędy'
}, {
  label: 'Dzieci od 3 do 12 lat',
  detail: 'Gotowe zajęcia, karty do druku i oceny dla rodziców'
}];
export const offerIncludes = ['Natychmiastowy dostęp cyfrowy', 'Pliki PDF do zachowania', 'Karty do druku', 'Nie wysyłamy produktu fizycznego'];
export const PRICE = '99 zł';
export const COMPARE_PRICE = '199 zł';

// Only add authentic reviews of PŁYWANIE GOTOWE. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Jak otrzymam materiał?',
  a: 'PŁYWANIE GOTOWE™ to produkt cyfrowy. Po zakupie otrzymasz dostęp do plików PDF, które możesz pobrać i zachować. Możesz korzystać z nich na komputerze, tablecie lub telefonie i drukować potrzebne karty.'
}, {
  q: 'Czy PŁYWANIE GOTOWE™ pasuje do polskich pływalni?',
  a: 'Tak. Materiał jest przygotowany dla instruktorów i instruktorek pływania prowadzących szkółki pływackie na pływalniach miejskich, w OSiR-ach i klubach sportowych: brodzik i duży basen, 45-minutowe kursy dla dzieci, zapisy we wrześniu, sezon od września do czerwca, ferie zimowe, kursy wakacyjne i półkolonie. Materiał nie zastępuje szkolenia ani nadzoru ratownika na pływalni.'
}, {
  q: 'Czy pasuje do każdego wieku?',
  a: 'Tak. Sześć tomów prowadzi przez etapy od 3 do 12 lat: oswojenie z wodą, unoszenie się na wodzie i oddychanie, pierwsze pływanie, kraul i styl grzbietowy, żabka i delfin, doskonalenie i bezpieczeństwo. Wybierasz według wieku i poziomu Twojej grupy.'
}, {
  q: 'Czy naprawdę przygotuję zajęcia w 5 minut?',
  a: 'PŁYWANIE GOTOWE™ jest zaprojektowane tak, żeby przyspieszyć przygotowanie. Otwierasz tom, wybierasz gotowe zajęcia i przeglądasz je w około pięć minut. Czas może się różnić w zależności od grupy i Twoich zmian.'
}, {
  q: 'Czy materiału wystarczy na cały sezon?',
  a: 'PŁYWANIE GOTOWE™ zawiera zajęcia i aktywności na cały sezon, od września do czerwca. Wybierasz, łączysz i dostosowujesz je do swojego planu i grupy.'
}, {
  q: 'Czy są karty gotowe do druku?',
  a: 'Tak. Pakiet zawiera karty zajęć, karty postępów dla rodziców i dyplomy do druku.'
}, {
  q: 'Czy ćwiczenia są bezpieczne dla dzieci?',
  a: 'Tak. Każde zajęcia podają odpowiednią głębokość, sprzęt, liczbę dzieci na instruktora i ramkę bezpieczeństwa. Na kolejny poziom przechodzi się dopiero wtedy, gdy dziecko jest gotowe.'
}, {
  q: 'Czy mogę pracować z różnymi poziomami?',
  a: 'Tak. Każde zajęcia mają 3 poziomy, żeby dzieci, które jeszcze boją się wody, i te, które już pływają, ćwiczyły razem w tej samej grupie.'
}, {
  q: 'Czy muszę wszystko drukować?',
  a: 'Nie. Drukujesz tylko te strony, których potrzebujesz, a resztę możesz wyświetlać na tablecie.'
}, {
  q: 'Czy pięć bonusów jest w cenie?',
  a: `Tak. Wszystkie pięć bonusów jest w pakiecie bez dodatkowych kosztów – całość za ${PRICE}.`
}, {
  q: 'Czy to abonament?',
  a: 'Nie. Płacisz jeden raz i otrzymujesz dostęp do materiałów cyfrowych. Bez żadnych cyklicznych opłat.'
}, {
  q: 'Czy mogę zachować pliki?',
  a: 'Tak. Możesz pobrać i zachować pliki PDF zgodnie z warunkami korzystania z produktu.'
}, {
  q: 'Czy mogę korzystać z telefonu lub tabletu?',
  a: 'Tak. Pliki PDF otworzysz na komputerze, tablecie i telefonie. Do sprawdzenia układu przed drukiem polecamy komputer lub tablet.'
}, {
  q: 'Czy jest gwarancja?',
  a: 'Tak. PŁYWANIE GOTOWE™ ma 7-dniową gwarancję satysfakcji. Jeśli materiał nie spełni Twoich oczekiwań, napisz do nas w okresie gwarancji i poproś o zwrot pieniędzy, zgodnie z warunkami.'
}];
export const footerLinks = ['Regulamin sprzedaży', 'Polityka prywatności', 'Polityka zwrotów', 'Kontakt'];